import script from "./OrderPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderPage.vue?vue&type=script&setup=true&lang=js"

import "./OrderPage.vue?vue&type=style&index=0&id=7c4a8174&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c4a8174"]])

export default __exports__